import { MainTemplate } from "@/components/templates";
import { css } from "@emotion/react";
import { ErrorWords } from "@/components/organisms/ErrorWords";
import { BizsolReturnButton } from "@/components/atoms";
import { PageTitle } from "@/components/molecules";
import config from "@/libs/config";

type Props = {
  message: string;
};

export const BizsolRequestErrorPage = ({ message }: Props) => {
  const displayBizsolReturnButton = config.IS_SHIKOKUBANK;

  return (
    <MainTemplate title={`${config.BANK_NICKNAME} Mikatano ID`}>
      <PageTitle
        mainTitle={`${config.BANK_NICKNAME} Mikatano ID`}
        subTitle={"Server Error"}
      />
      {displayBizsolReturnButton ? <BizsolReturnButton /> : null}
      <ErrorWords>
        メンテナンス中、または何らかの障害が発生している可能性があります。
        <br />
        メンテナンス終了もしくは復旧までしばらくお待ちください。
        <br />
        <br />[<>{message}</>]
      </ErrorWords>
    </MainTemplate>
  );
};

const msgWapper = css({
  width: "100%",
  textAlign: "left",
});

const olWapper = css({
  width: "100%",
  padding: "0",
});

const aWapper = css({
  color: "#1A73E8",
});
